// alert(1);
if (!customElements.get("product-media")) {
  customElements.define("product-media",class ProductSlick extends HTMLElement {
      slider = undefined;
      variantData = undefined;
      constructor() {
        super();
      }
      slickFilter(handle=null) {
        if(theme.productTags.includes('enchanted-star') && parseInt(theme.productOptionSize) > 1){
            let variantHandle = handle;
            if(!variantHandle) {
              var selectElement = document.querySelector('.product-form__variants');
              const selectedOption = selectElement.options[selectElement.selectedIndex];
              variantHandle = selectedOption.dataset.variantHandle;
            }
            console.log("variantHandle",variantHandle);
            setTimeout(() => {
                this.slider.slick("slickUnfilter");
                this.slider.slick("slickFilter", `.all, .${variantHandle}`);
                var slickPaginationLength = document.querySelectorAll('.product__media-list .slick-dots li');
                console.log(slickPaginationLength.length);
                document.querySelector('.slider-mobile-gutter').dataset.slickLength = slickPaginationLength.length;
            },100);
        }else{
          var slickPaginationLength = document.querySelectorAll('.product__media-list .slick-dots li');
          document.querySelector('.slider-mobile-gutter').dataset.slickLength = slickPaginationLength.length;
        }
      }
      slickSlider() {
        // if(window.innerWidth<750){
        //     this.slider = $(".product__media-list").slick({
        //         slidesToShow: 1,
        //         infinite: false,
        //         slidesToScroll: 1,
        //         rows: 0,
        //         arrows:true,
        //         prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret rotate-left" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
        //         nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret rotate-right" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
        //         dots:true,
        //     });
        //     this.slickFilter();
        // }
      }
      connectedCallback() {
        this.slickSlider();
        this.variantData = subscribe(
          PUB_SUB_EVENTS.variantData,
          this.handleVariantDataChange.bind(this)
        );
      }

      disconnectedCallback() {
        if (this.variantData) {
          this.variantData();
        }
      }
      handleVariantMetaDataChange(data) { 
        return;
      }
      handleVariantDataChange({variant,imageHandle}) {
        console.log("variant data received", variant, imageHandle);  // For testing purposes only. Remove when ready.
        this.handleVariantMetaDataChange(variant)
        if(window.innerWidth<750){
            this.slickFilter(imageHandle);
        }
      }
    }
  );
}
